import script from "./WebVideoStream.vue?vue&type=script&setup=true&lang=js"
export * from "./WebVideoStream.vue?vue&type=script&setup=true&lang=js"

import "./WebVideoStream.vue?vue&type=style&index=0&id=666bccf1&scoped=true&lang=scss"
import "./WebVideoStream.vue?vue&type=style&index=1&id=666bccf1&lang=scss"
import "./WebVideoStream.vue?vue&type=style&index=2&id=666bccf1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-666bccf1"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QInput,QBtn});
